import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to New Orleans needed",
      "Ideal for oil & gas engineers on international rotation",
      "Perfect for UL Lafayette students studying abroad",
      "Great for Acadian families visiting France and Canada",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Lafayette post offices",
      "Good for planned international trips from LFT",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at local facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: New Orleans — no Acadiana walk-in",
      "NPIC appointment required before traveling to New Orleans",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function LafayetteProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Lafayette"
      headingExtra="LA"
      introText="Lafayette travelers — oil & gas engineers heading to offshore rigs or international rotations, UL Lafayette students studying abroad, and Acadian families visiting family roots in France and Canada — have several options for getting a passport fast. Here is how they compare, and why most Acadiana residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the I-10 drive to New Orleans."
      options={options}
      emergencyDescription="Lafayette has no regional passport agency. Closest is New Orleans ~135 mi via I-10 (2+ hrs). Louisiana's single agency serves the entire state — from Shreveport to the bayou. Hurricane evacuation traffic clogs I-10 June–Nov. I-10 bridge closures between Baton Rouge and Lafayette during high water/flooding events can sever the route to New Orleans entirely, leaving Acadiana travelers stranded."
      disclaimerText="*Processing speed depends on eligibility and documentation. Lafayette does not have a regional passport agency — the closest is New Orleans. Not all applicants qualify for Regional Agency Processing."
    />
  );
}